import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getAssignment,
  getVideosBySubCategory,
  getEmptyQuestionObject,
  saveAssignment,
  deleteQuestion,
  deleteAnswer,
  getEmptyAnswerObject
} from "../../../../data-service-admin";
import { getTotalQuestions } from "../../../../localstorage-service";
import { ToastContainer } from "react-toastr";
import { showToastMessage, showErrorToastMessage, emptyCheck } from "../../../../utilities";
import Spinner from "../../../User/Common/Spinner/Spinner";
import AdminBreadcrumb from "../Common/Breadcrumb";
import { Radio, Checkbox } from "react-bootstrap";
import { ASSIGNMENT_IMAGE_PATH } from "../../../../constants";
// import * as CONSTANT from "../../../../constants";

class AdminAssignment extends Component {
  state = {
    questions: [],
    question: {},
    showSpinner: false,
    errorMessage: "",
    videos: [],
    videosBySubCategory: []
  };
  componentDidMount() {
    console.log(this.props);
    this.getVideosBySubCategory();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }

  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }
  getVideosBySubCategory() {
    this.showSpinner(true);
    let videosBySubCategory = [];
    getVideosBySubCategory(this.props.match.params.id)
      .then(response => {
        console.log(response.data);
        for (let video of response.data) {
          videosBySubCategory.push(
            <option key={video.Id} value={video.Id}>
              {video.Name}
            </option>
          );
        }
        this.setState({ videos: response.data, videosBySubCategory: videosBySubCategory });
        this.getAssignmentFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }
  getAssignmentFromService() {
    console.log("getVideosFromService");
    getAssignment(this.props.match.params.id).then(response => {
      console.log(response.data);
      this.showSpinner(false);
      this.setState({ questions: response.data.questions, subcategoryname: response.data.SubCategoryName });
    });
  }
  questionTextChanged = (event, Id) => {
    let questions = this.state.questions;
    questions.filter(d => d.Id === Id)[0].QuestionText = event.target.value;
    this.setState({
      questions: questions
    });
  };

  imageUrlChanged = (event, Id) => {
    let questions = this.state.questions;
    questions.filter(d => d.Id === Id)[0].ImageUrl = event.target.value;
    this.setState({
      questions: questions
    });
  };

  answerChanged = (event, questionId, answerId, type) => {
    let questions = this.state.questions;
    if (type === "answertext") {
      questions.filter(d => d.Id === questionId)[0].answers.filter(d => d.Id === answerId)[0].AnswerText =
        event.target.value;
    } else if (type === "radio") {
      const answers = questions.filter(d => d.Id === questionId)[0].answers;
      for (let i = 0; i < answers.length; i++) {
        questions.filter(d => d.Id === questionId)[0].answers[i].IsCorrectAnswer = false;
      }
      questions.filter(d => d.Id === questionId)[0].answers.filter(d => d.Id === answerId)[0].IsCorrectAnswer =
        event.target.checked;
    } else if (type === "checkbox") {
      if (event.target.value === "on") {
        questions.filter(d => d.Id === questionId)[0].answers.filter(d => d.Id === answerId)[0].IsCorrectAnswer =
          event.target.checked;
      } else {
        questions.filter(d => d.Id === questionId)[0].answers.filter(d => d.Id === answerId)[0].IsCorrectAnswer =
          event.target.checked;
      }
    }
    this.setState({
      questions: questions
    });
    console.log(this.state.questions);
  };
  questionTypeChanged = (event, questionId) => {
    console.log(event.target.value);
    let questions = this.state.questions;
    questions.filter(d => d.Id === questionId)[0].QuestionTypeId = parseInt(event.target.value, 10);
    const answers = questions.filter(d => d.Id === questionId)[0].answers;
    for (let i = 0; i < answers.length; i++) {
      questions.filter(d => d.Id === questionId)[0].answers[i].IsCorrectAnswer = false;
    }
    this.setState({
      questions: questions
    });
    console.log(this.state.questions);
  };
  selectedVideoChanged = (event, questionId) => {
    console.log(event.target.value);
    let questions = this.state.questions;
    questions.filter(d => d.Id === questionId)[0].VideoId = parseInt(event.target.value, 10);
    this.setState({
      questions: questions
    });
    console.log(this.state.questions);
  };
  addQuestion() {
    this.showSpinner(true);
    let questions = this.state.questions;
    getEmptyQuestionObject(this.props.match.params.id).then(response => {
      console.log(response.data);
      questions.push(response.data);
      console.log(questions);
      this.setState({ question: response.data });
      this.showSpinner(false);
    });
  }
  validate(questions) {
    for (let i = 0; i < questions.length; i++) {
      if (emptyCheck(questions[i].QuestionText)) {
        showToastMessage("error", `Error: Question ${i + 1}`, `Please enter question text`, this, "toastr1");
        return false;
      }
      if (questions[i].VideoId === -1) {
        showToastMessage("error", `Error: Question ${i + 1}`, `Please select reference video`, this, "toastr1");
        return false;
      }
      if (
        questions[i].ImageUrl !== null &&
        questions[i].ImageUrl !== "" &&
        questions[i].ImageUrl.indexOf(ASSIGNMENT_IMAGE_PATH) === -1
      ) {
        showToastMessage("error", `Error: Question ${i + 1}`, `Image Url not valid`, this, "toastr1");
        return false;
      }
      let IsCorrectAnswer = false;

      for (let j = 0; j < questions[i].answers.length; j++) {
        if (emptyCheck(questions[i].answers[j].AnswerText)) {
          showToastMessage("error", `Error: Question ${i + 1}`, `Please enter all answers`, this, "toastr1");
          return false;
        }
        if (questions[i].answers[j].IsCorrectAnswer) {
          IsCorrectAnswer = true;
        }
      }
      if (!IsCorrectAnswer) {
        showToastMessage("error", `Error: Question ${i + 1}`, `Please mark one answer as correct`, this, "toastr1");
        return false;
      }

      let correctanswer = [];
      for (let j = 0; j < questions[i].answers.length; j++) {
        if (questions[i].answers[j].IsCorrectAnswer) {
          correctanswer.push(1);
        }
      }

      if (questions[i].QuestionTypeId === 2 && correctanswer.length < 2) {
        showToastMessage(
          "error",
          `Error: Question ${i + 1}`,
          `Please mark atleast two answers as correct`,
          this,
          "toastr1"
        );
        return false;
      }
    }
    return true;
  }

  save() {
    if (this.validate(this.state.questions)) {
      this.showSpinner(true);
      saveAssignment(this.state.questions)
        .then(response => {
          if (this.state.questions.length < getTotalQuestions()) {
            showToastMessage(
              "warning",
              "Warning",
              `Self Assessment will not appear in application unless ${getTotalQuestions()} or more questions are uploaded.`,
              this,
              "toastr1"
            );
            showToastMessage("success", "Success", "Assessment saved successfully!", this, "toastr1");
          } else {
            showToastMessage("success", "Success", "Assessment published successfully!", this, "toastr1");
          }
          this.showSpinner(false);
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
  delete(id) {
    this.showSpinner(true);
    deleteQuestion(id)
      .then(response => {
        let questions = this.state.questions;
        const idx = questions.findIndex(d => d.Id === id);
        questions.splice(idx, 1);
        this.setState({
          questions: questions
        });
        showToastMessage("success", "Success", `Question ${idx + 1} deleted successfully!`, this, "toastr1");
        this.showSpinner(false);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  }
  addAnswer(questionid) {
    this.showSpinner(true);
    getEmptyAnswerObject(questionid)
      .then(response => {
        let questions = this.state.questions;
        questions.find(d => d.Id === questionid).answers.push(response.data);
        this.setState({
          questions: questions
        });
        showToastMessage("success", "Success", `Answer added successfully!`, this, "toastr1");
        this.showSpinner(false);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  }
  deleteAnswer(questionid, answerid) {
    this.showSpinner(true);
    deleteAnswer(answerid)
      .then(response => {
        let questions = this.state.questions;
        const idx = questions.filter(d => d.Id === questionid)[0].answers.findIndex(d => d.Id === answerid);
        questions.find(d => d.Id === questionid).answers.splice(idx, 1);
        this.setState({
          questions: questions
        });
        showToastMessage("success", "Success", `Answer ${idx + 1} deleted successfully!`, this, "toastr1");
        this.showSpinner(false);
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  }
  render() {
    const questions = this.state.questions;
    const assessmentQuestions = questions.map((d, i) => {
      return (
        <div key={"questiondiv" + d.Id} className="col-md-12">
          <div className="form-group">
            <label className="pull-left">
              <strong>Question {i + 1}: </strong>
            </label>
            <div className="pull-right">
              <button className="btn btn-primary del-btn-assignment" onClick={Id => this.delete(d.Id)}>
                Delete
              </button>
            </div>
            <input
              type="text"
              className="form-control"
              ref="txtQuestionText"
              value={d.QuestionText}
              onChange={(e, Id) => this.questionTextChanged(e, d.Id)}
            />
          </div>
          <div className="form-group">
            <label className="pull-left">
              <strong>Question Type: </strong>
            </label>
            <select
              className="form-control"
              value={d.QuestionTypeId}
              onChange={(e, qId) => this.questionTypeChanged(e, d.Id)}
            >
              <option value="1">Radio</option>
              <option value="2">Checkbox</option>
            </select>
          </div>
          {/* <div className="form-group">
            <label className="pull-left">
              <strong>Image Url ({ASSIGNMENT_IMAGE_PATH}[INSERT_YOUR_IMAGE_NAME_HERE.jpg]): </strong>
              <br />
              <i className="text-danger">
                **Image name should not contain special characters. Correct standard: abx11.jpg or abx_11.jpg or
                abx-11.jpg
              </i>
            </label>
            <input
              type="text"
              className="form-control"
              ref="txtImageUrl"
              value={d.ImageUrl}
              onChange={(e, Id) => this.imageUrlChanged(e, d.Id)}
            />
          </div> */}
          <div className="form-group">
            <label className="pull-left">
              <strong>Answers: </strong>
            </label>
            <br />
            {d.answers.map((answer, answerindex) => {
              return (
                <Aux key={"answeraux" + answer.Id}>
                  {d.QuestionTypeId === 1 && (
                    <Radio
                      checked={answer.IsCorrectAnswer}
                      name={"group" + answer.QuestionId}
                      className="assignmentradio"
                      onChange={(e, qId, aId, type) => this.answerChanged(e, d.Id, answer.Id, "radio")}
                    >
                      <input
                        type="text"
                        className="form-control width93per pull-left"
                        ref="txtQuestionText"
                        onChange={(e, qId, aId, type) => this.answerChanged(e, d.Id, answer.Id, "answertext")}
                        value={answer.AnswerText}
                      />
                      <button
                        className="btn btn-primary pull-right"
                        onClick={(questionid, answerid) => this.deleteAnswer(d.Id, answer.Id)}
                      >
                        Delete
                      </button>
                    </Radio>
                  )}
                  {d.QuestionTypeId === 2 && (
                    <Checkbox
                      checked={answer.IsCorrectAnswer}
                      className="assignmentcheckbox"
                      onChange={(e, qId, aId, type) => this.answerChanged(e, d.Id, answer.Id, "checkbox")}
                      name={"group" + answer.QuestionId}
                    >
                      <input
                        type="text"
                        className="form-control width93per pull-left"
                        ref="txtQuestionText"
                        onChange={(e, qId, aId, type) => this.answerChanged(e, d.Id, answer.Id, "answertext")}
                        value={answer.AnswerText}
                      />
                      <button
                        className="btn btn-primary pull-right"
                        onClick={answerid => this.deleteAnswer(d.Id, answer.Id)}
                      >
                        Delete
                      </button>
                    </Checkbox>
                  )}
                </Aux>
              );
            })}
          </div>
          <button className="btn btn-primary mb-10" onClick={answerid => this.addAnswer(d.Id)}>
            Add Answer
          </button>
          <div className="form-group">
            <label className="pull-left">
              <strong>Video: </strong>
            </label>
            <select
              ref="selVideo"
              className="form-control"
              value={d.VideoId}
              onChange={(e, qId) => this.selectedVideoChanged(e, d.Id)}
            >
              <option value={-1}>Select Video</option>
              {this.state.videosBySubCategory}
            </select>
          </div>

          <hr />
        </div>
      );
    });

    return (
      <Aux>
        <h1 className="page-header">Assessment</h1>
        <AdminBreadcrumb
          data={[
            { name: "Home", link: "/admin/modules" },
            { name: "Modules", link: "/admin/modules/" },
            { name: "Categories", link: `/admin/${this.props.match.params.moduleid}/categories/` },
            {
              name: "Learning Categories",
              link: `/admin/${this.props.match.params.moduleid}/${this.props.match.params.learningid}/learningcategories/`
            },
            { name: "Assessment" }
          ]}
        />
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        {assessmentQuestions}
        <button className="btn btn-primary" onClick={() => this.addQuestion()}>
          Add Question
        </button>
        <button className="btn btn-primary ml-10" onClick={() => this.save()}>
          Save
        </button>
      </Aux>
    );
  }
}

export default AdminAssignment;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Assignment/Assignment.js